import qs, { ParsedQs } from 'qs';

export function parseQueryParams<T extends ParsedQs = ParsedQs>() {
  return qs.parse(window.location.search, { ignoreQueryPrefix: true }) as T;
}

export function stringifyQueryParams(obj: unknown) {
  return qs.stringify(obj);
}
